module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0124-msyozoku/msyozoku.component.css
// module id = ./src/app/a0124-msyozoku/msyozoku.component.css
// module chunks = main